import { Fragment } from 'react'
import { translateManager as t } from '../../../services/TranslateManager'
import { getSizeName } from '../../../services/SizesManager'
import SingleCouponSection from './SingleCouponSection'
import And from './And'

interface TileCreditCoupon {
  code: string
  sourceCoupon: string
  amount: number
  metadata?: {
    tileSizesList?: string[]
  }
}

interface TileCreditsSectionProps {
  tileCreditCoupons: TileCreditCoupon[]
}

function TileCreditsSection({ tileCreditCoupons }: TileCreditsSectionProps) {
  if (tileCreditCoupons.length === 0) return null

  return (
    <>
      {tileCreditCoupons.map((coupon) => (
        <Fragment key={coupon.code}>
          <SingleCouponSection
            headerTitle={t.get('general.promo_code_selector.free_tiles')}
            title={coupon.sourceCoupon}
            subtitle={t.get(
              'general.promo_code_selector.free_tile_description',
              {
                v1: coupon.amount,
                v2:
                  coupon?.metadata?.tileSizesList?.length !== 1
                    ? ''
                    : getSizeName(coupon.metadata.tileSizesList[0]),
              }
            )}
            dataTestId={coupon.sourceCoupon}
          />
          <And />
        </Fragment>
      ))}
    </>
  )
}

export default TileCreditsSection
